import { Skeleton } from "@/app/admin/_common/ui/skeleton";
import { useIsMobile } from "@/app/admin/_hooks/useIsMobile";

export default function FestivalListSkeleton() {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <div className="flex flex-col bg-card">
        {Array.from({ length: 6 }).map((_, i) => (
          <div
            key={i}
            className="flex flex-col gap-1.5 border-b border-border px-4 py-3 last:border-0"
          >
            <div className="flex items-center justify-between gap-2">
              <Skeleton className="h-4 w-32" />
              <Skeleton className="h-5 w-20 rounded-[7px]" />
            </div>
            <Skeleton className="h-3 w-16" />
            <Skeleton className="h-3 w-28" />
            <Skeleton className="h-3 w-24" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden border-t border-border bg-card md:rounded-md md:border md:border-border">
      <div className="flex h-8 items-center gap-4 border-b border-border/50 bg-muted/50 px-4">
        <Skeleton className="h-3 w-32" />
        <Skeleton className="h-3 w-10" />
        <Skeleton className="h-3 w-20" />
        <Skeleton className="h-3 w-24" />
        <Skeleton className="ml-auto h-3 w-20" />
      </div>
      {Array.from({ length: 8 }).map((_, i) => (
        <div
          key={i}
          className="flex h-[46px] items-center gap-4 border-b border-border/50 px-4 last:border-0"
        >
          <Skeleton className="h-3 w-32" />
          <Skeleton className="h-3 w-10" />
          <Skeleton className="h-3 w-20 rounded-full" />
          <Skeleton className="h-1.5 w-24 rounded-full" />
          <Skeleton className="ml-auto h-3 w-20" />
          <Skeleton className="size-4 flex-none rounded" />
        </div>
      ))}
    </div>
  );
}
